<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">
    <template v-slot:activator="{on}">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Agendar
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <tw-autocomplete-clientes
            v-model="agendamentoEdit.cliente"
            class="required"
            :error="$v.agendamentoEdit.cliente.$error"
            @blur="$v.agendamentoEdit.cliente.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="agendamentoEdit.anotacao"
            label="Anotações"
            auto-grow
            outlined
            rows="1"
            row-height="15"
            maxlength="255"
            hide-details
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <tw-select-enum
            :disabled="!!this.agendamentoEdit.id"
            label="Repetir agendamento"
            class="required"
            :error="$v.agendamentoEdit.tipo.$error"
            @blur="$v.agendamentoEdit.tipo.$touch()"
            v-model="agendamentoEdit.tipo"
            :items="tipos"/>
        </v-col>
        <v-col cols="6" sm="6" md="6" v-if="this.repete">
          <tw-date-picker
            input-class="required"
            label="Data início"
            v-model="agendamentoEdit.dataInicio"
            :error="$v.agendamentoEdit.dataInicio.$error"
            @blur="$v.agendamentoEdit.dataInicio.$touch()"
          />
        </v-col>
        <v-col cols="6" sm="6" md="6" v-if="this.repete">
          <tw-date-picker
            input-class="required"
            label="Data fim"
            v-model="agendamentoEdit.dataFim"
            :error="$v.agendamentoEdit.dataFim.$error"
            @blur="$v.agendamentoEdit.dataFim.$touch()"
            maxValue
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" v-if="!this.repete">
          <tw-date-picker
            input-class="required"
            label="Data"
            v-model="agendamentoEdit.dataInicio"
          />
        </v-col>
      </v-row>
      <div v-if="this.repete">
        <tw-agendamento-dia
          v-for="(item, key) in this.agendamentoEdit.itens"
          :key="key"
          :item="item"
          :dia-semana="key"
        />
      </div>
      <div v-else>
        <v-row dense>
          <v-col>
            <tw-time-picker
              label="Hora início"
              input-class="required"
              v-model="horaInicio"
            />
          </v-col>
          <v-col>
            <tw-time-picker
              input-class="required"
              v-model="horaFim"
              label="Hora fim"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             :loading="loadingForm"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>

  </tw-custom-dialog>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import AgendamentoService from '@/api/agendamento-service';
import ClientesAutocomplete from '@/modules/cliente/ClientesAutocomplete.vue';
import diasSemana from '@/enums/day-of-week';
import agendamentoTipo from '@/enums/agendamento-tipo';
import { cloneDeep } from 'lodash';
import AgendamentoDia from './AgendamentoDia.vue';

const defaultItem = {
  enabled: false,
  horaFim: null,
  horaInicio: null,
};

const reset = () => ({
  cliente: null,
  anotacao: null,
  dataInicio: null,
  dataFim: null,
  tipo: null,
  itens: {
    MONDAY: { enabled: false, ...defaultItem },
    TUESDAY: { enabled: false, ...defaultItem },
    WEDNESDAY: { enabled: false, ...defaultItem },
    THURSDAY: { enabled: false, ...defaultItem },
    FRIDAY: { enabled: false, ...defaultItem },
    SATURDAY: { enabled: false, ...defaultItem },
    SUNDAY: { enabled: false, ...defaultItem },
  },
});

export default {
  props: {
    agendamento: Object,
  },
  data() {
    return {
      dialog: false,
      dialogDataIni: false,
      dialogDataFim: false,
      enumselecionado: null,
      diasSemana: diasSemana.values,
      horaInicio: null,
      horaFim: null,
      idHorario: null,
      agendamentoEdit: reset(),
      tipos: agendamentoTipo.values,
      loadingForm: false,
    };
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.getAgendamento();
        return;
      }
      this.$v.$reset();
    },
  },
  computed: {
    repete: {
      get() {
        return this.agendamentoEdit.tipo === agendamentoTipo.keys.SEMANALMENTE.key;
      },
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    descricaoDiaSemana(key) {
      return diasSemana.keys[key].description;
    },
    save() {
      this.loadingForm = true;
      AgendamentoService.save(this.toSave())
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Agendamento salvo!', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    getAgendamento() {
      this.agendamentoEdit = reset();
      if (!this.agendamento) {
        return;
      }
      this.loadingForm = true;
      AgendamentoService.get(this.agendamento.id)
        .then((data) => {
          this.onLoad(data.data);
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    onLoad(data) {
      if (!data) {
        return;
      }
      this.agendamentoEdit.id = data.id;
      this.agendamentoEdit.tipo = data.tipo;
      this.agendamentoEdit.cliente = data.cliente;
      this.agendamentoEdit.anotacao = data.anotacao;
      this.agendamentoEdit.dataInicio = data.dataInicio;
      this.agendamentoEdit.dataFim = data.dataFim;
      if (!this.repete) {
        this.horaInicio = data.itens[0].horaInicio;
        this.horaFim = data.itens[0].horaFim;
        this.idHorario = data.itens[0].id;
      } else {
        data.itens.forEach((item) => {
          this.agendamentoEdit.itens[item.diaSemana].horaInicio = item.horaInicio;
          this.agendamentoEdit.itens[item.diaSemana].horaFim = item.horaFim;
          this.agendamentoEdit.itens[item.diaSemana].id = item.id;
          this.agendamentoEdit.itens[item.diaSemana].enabled = true;
        });
      }
    },
    toSave() {
      const toSave = cloneDeep(this.agendamentoEdit);
      delete toSave.itens;
      if (!this.repete) {
        toSave.dataFim = toSave.dataInicio;
        const weekday = this.$moment(toSave.dataInicio)
          .weekday();
        const diaSemana = diasSemana.values
          .find((a) => a.value === weekday).key;
        toSave.itens = [this.montarItem(this.idHorario, diaSemana, this.horaInicio, this.horaFim)];
      } else {
        toSave.itens = [];
        Object.entries(this.agendamentoEdit.itens)
          .forEach(([key, item]) => {
            if (item.enabled) {
              toSave.itens.push(this.montarItem(item.id, key, item.horaInicio, item.horaFim));
            }
          });
      }
      return toSave;
    },
    montarItem(id, diaSemana, horaInicio, horaFim) {
      const item = {
        diaSemana,
        horaInicio,
        horaFim,
      };
      if (id) {
        item.id = id;
      }
      return item;
    },
  },
  components: {
    twAutocompleteClientes: ClientesAutocomplete,
    twAgendamentoDia: AgendamentoDia,
  },
  validations: {
    agendamentoEdit: {
      cliente: {
        required,
      },
      tipo: {
        required,
      },
      dataInicio: {
        required,
      },
      dataFim: {
        required: requiredIf(function () {
          return this.repete;
        }),
        maxValue: function validateMaxValue(date) {
          return !this.repete || this.agendamentoEdit.dataInicio < date;
        },
      },
    },
    horaInicio: {
      required: requiredIf(function () {
        return !this.repete;
      }),
    },
    horaFim: {
      required: requiredIf(function () {
        return !this.repete;
      }),
    },
  },
};
</script>
